import * as d3 from 'd3';

const INK = '#1A202C';

/**
 * Injects visual-reference SVG markup into a D3-owned SVG for DMN / VSM blocks.
 */
export function appendNotationMarkup(
  svg: d3.Selection<SVGSVGElement, unknown, null, undefined>,
  viewBox: string,
  markup: string,
  width: number,
  height: number,
  instanceId: string
) {
  const scoped = markup
    .replace(/\bid="([^"]+)"/g, (_m, id: string) => `id="${instanceId}-${id}"`)
    .replace(/url\(#([^)]+)\)/g, (_m, id: string) => `url(#${instanceId}-${id})`)
    // Prefer currentColor-friendly ink when fill/stroke is the reference black.
    .replace(/stroke="#1A202C"/g, `stroke="${INK}"`)
    .replace(/fill="#1A202C"/g, `fill="${INK}"`);

  svg
    .attr('viewBox', viewBox)
    // Stretch to the block box so the glyph fills the outer hit area (no letterboxing).
    .attr('preserveAspectRatio', 'none')
    .attr('width', width)
    .attr('height', height)
    .html(scoped);

  return svg;
}

export function createNotationBlockBackground(
  parent: d3.Selection<HTMLDivElement, unknown, null, undefined>,
  viewBox: string,
  markup: string,
  width: number,
  height: number,
  instanceId: string
) {
  parent.style('background-color', 'transparent');
  parent.style('border', 'none');

  const svg = parent
    .append('svg')
    .attr('width', width)
    .attr('height', height)
    .style('position', 'absolute')
    .style('top', '0')
    .style('left', '0')
    .style('overflow', 'visible')
    .style('pointer-events', 'none');

  appendNotationMarkup(svg, viewBox, markup, width, height, instanceId);
  return svg;
}
